// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__bBqlo","circle":"styles_circle__10Cu0","icon":"styles_icon__1-7WH","text":"styles_text__3G0o_"};